import type { AxiosRequestConfig } from "axios";
import { getCurrentUserCenterDevEnvKey, isLocalDebugHost } from "@user-center/utils/devSite";

export default function (config?: AxiosRequestConfig<any>): string {
  let baseUrl = "/siteapi/collectionSite/mall";

  if (typeof window !== "undefined") {
    const siteSplit = window.location.host.split(".");
    if (isLocalDebugHost(window.location.host)) {
      const currentDevEnvKey = getCurrentUserCenterDevEnvKey();
      baseUrl = currentDevEnvKey === "test"
        ? "http://xjhy.shopmember-test.omszt.com:7888/api/mall/"
        : "/siteapi/collectionSite/mall";
    } else if (siteSplit[1] && siteSplit[1].indexOf("test") >= 0) {
      baseUrl = "http://xjhy.shopmember-test.omszt.com:7888/api/mall/";
    }
 
    /*
    switch (window.location.port) {
      case "3000":
        baseUrl = "http://xjhy.m-shop-test.omszt.com:7888/api/mall/";
        break;
      case "8088":
        baseUrl = "http://xjhy.shopmember-test.omszt.com:7888/api/mall/";
        break;
      case "8089":
        baseUrl = "http://xjhy.shopmember-test.omszt.com:7888//api/mall/";
        break;
      case "7775":
      case "8090":
      case "8199":
        baseUrl = "https://api-tmall-test.omszt.com/mall/";
        break;
      case "7788":
        baseUrl = "http://xjhy.m-shop-test.omszt.com:7888/api/mall/";
        break;
      case "9528":
        baseUrl = "http://api-bms-test.sjscm.com/";
        break;
      case "9529":
        baseUrl = "http://api-bms-test.sjscm.com/";
        break;
      case "9530":
        baseUrl = "http://api-adminfront.bmsdev.itsjsc.com:8899";
        break;
      default:
        break;
    }

    if (window.location.host === "xjhy.buyagent.omszt.com:8081") {
      baseUrl = "http://tm.m-shop-test.omszt.com/api/mall/";
    }
      */
  }

  return baseUrl;
}
